"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const addDays_1 = __importDefault(require("date-fns/addDays"));
const react_2 = __importDefault(require("react"));
const useLangContext_1 = require("../../hooks/useLangContext");
const ThemeProvider_1 = require("../../theme/ThemeProvider");
const date_1 = require("../../utils/date");
const formatDate_1 = __importDefault(require("../../utils/formatDate"));
const Text_1 = __importDefault(require("../_core/Text"));
const Header_1 = __importDefault(require("../Header"));
const PaymentMentions_1 = require("../PaymentMentions");
const Tasks_1 = __importDefault(require("../Tasks"));
const Payment_1 = require("./components/Payment");
const useTagForInvoiceStatus_1 = require("./hooks/useTagForInvoiceStatus");
const locales_1 = __importDefault(require("./locales"));
const InvoiceComponent = ({ invoice }) => {
    var _a;
    const { lang, syncLocales } = (0, useLangContext_1.useLangContext)();
    syncLocales(locales_1.default);
    const legalMentions = (_a = invoice.settings.legalMentions) !== null && _a !== void 0 ? _a : [];
    const startAt = (0, formatDate_1.default)(invoice.startAt, date_1.FORMATS.P, lang);
    const dueDate = (0, formatDate_1.default)((0, addDays_1.default)(invoice.startAt, invoice.lateMaxDays), date_1.FORMATS.P, lang);
    const statusTag = (0, useTagForInvoiceStatus_1.useTagForInvoiceStatus)(invoice.status);
    const headerDirection = invoice.logoUrl ? 'right' : 'left';
    return (react_2.default.createElement(react_1.Flex, { flex: 1, flexDirection: "column", height: "100%", overflow: "hidden", padding: "space-24", position: "relative" },
        react_2.default.createElement(react_1.Box, { marginBottom: "space-32" },
            react_2.default.createElement(Header_1.default, { entity: invoice },
                react_2.default.createElement(react_1.Flex, { alignItems: "center", direction: headerDirection === 'right' ? 'row' : 'row-reverse', gap: "space-8", justifyContent: "flex-end" },
                    statusTag,
                    react_2.default.createElement(Text_1.default, { size: "lg" }, locales_1.default.formatString(locales_1.default.fiscalId, {
                        fiscalId: invoice.fiscalId,
                    }))),
                react_2.default.createElement(react_1.Flex, { alignItems: "center", gap: "2px", justifyContent: headerDirection === 'right' ? 'flex-end' : 'flex-start' },
                    react_2.default.createElement(Text_1.default, null, locales_1.default.startAt),
                    react_2.default.createElement(Text_1.default, null, startAt)),
                react_2.default.createElement(react_1.Flex, { alignItems: "center", gap: "2px", justifyContent: headerDirection === 'right' ? 'flex-end' : 'flex-start' },
                    react_2.default.createElement(Text_1.default, null, locales_1.default.dueDate),
                    react_2.default.createElement(Text_1.default, null, dueDate)))),
        react_2.default.createElement(react_1.Stack, { marginBottom: "space-16" },
            react_2.default.createElement(Text_1.default, { fontWeight: "weight-500", lineHeight: "lh-16", size: "lg" }, invoice.title),
            invoice.subtitle ? react_2.default.createElement(Text_1.default, null, invoice.subtitle) : null),
        react_2.default.createElement(react_1.Box, { marginBottom: "space-40" },
            react_2.default.createElement(Tasks_1.default, { currency: invoice.currency, particularMentions: invoice.particularMentions, prices: {
                    amountAfterTaxes: invoice.totalAmountAfterTaxes,
                    amountBeforeTaxes: invoice.totalAmountBeforeTaxes,
                    vatAmount: invoice.totalVatAmount,
                }, tasks: invoice.tasks })),
        react_2.default.createElement(Payment_1.Payment, { invoice: invoice }),
        react_2.default.createElement(react_1.Spacer
        // minHeight does not support space-* foundations values
        , { 
            // minHeight does not support space-* foundations values
            minHeight: "24px" }),
        react_2.default.createElement(PaymentMentions_1.PaymentMentions, { paymentMentions: [...invoice.paymentMentions, ...legalMentions] })));
};
const Invoice = ({ lang, ...props }) => (react_2.default.createElement(ThemeProvider_1.ThemeProvider, null,
    react_2.default.createElement(useLangContext_1.LangContextProvider, { lang: lang },
        react_2.default.createElement(InvoiceComponent, { ...props }))));
exports.default = Invoice;
